// export DisposeIdea from "./disposeIdea";
// export FlowInfo from "./flowInfo";
// export FlowProcess from "./flowProcess";
// export FormCommentBox from "./formCommentBox";

// export ChooseSendNode from "./chooseSendNode";
// export ChooseSendTree from "./chooseSendTree";
// export DsfFlowAddComment from "./flowAddComment";
// export DsfFlowSelectTree from "./selectTree";
export const DsfDisposeIdea=dsf.defineLazyComponent('DsfDisposeIdea',()=>require('./disposeIdea'));
export const DsfFlowInfo=dsf.defineLazyComponent('DsfFlowInfo',()=>require('./flowInfo'));
export const DsfFlowProcess=dsf.defineLazyComponent('DsfFlowProcess',()=>require('./flowProcess'));
export const DsfFormCommentBox=dsf.defineLazyComponent('DsfFormCommentBox',()=>require('./formCommentBox'));


export const DsfFlowAddComment = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_flow" */ "./flowAddComment"));
export const DsfFlowSelectTree = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_flow" */ "./selectTree"));
export const ChooseSendNode = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_flow" */ "./chooseSendNode"));
export const ChooseSendTree = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_flow" */ "./chooseSendTree"));
